/**
 * Placeholder cover for the pre-data scaffold: an unjacketed book board with the
 * title set in Fraunces. Phase 2 replaces this with a Cloudinary <img> using the
 * `grid` transform preset; the surrounding markup and the lift-on-hover stay.
 */
export default function CoverPlaceholder({ title, author, tone = 0 }) {
  const tones = ['bg-paper-deep', 'bg-navy', 'bg-stamp'];
  const surface = tones[tone % tones.length];
  const onDark = surface !== 'bg-paper-deep';

  return (
    <div
      className={`${surface} border-rule/60 flex aspect-2/3 flex-col justify-between border p-4`}
      aria-hidden="true"
    >
      <span className={`label ${onDark ? 'text-paper/75' : 'text-ink-60'}`}>Chapters&amp;Co</span>
      <span
        className={`font-display text-lg leading-tight ${onDark ? 'text-paper' : 'text-ink'}`}
        style={{ fontVariationSettings: "'SOFT' 20, 'WONK' 1, 'opsz' 40" }}
      >
        {title}
      </span>
      <span className={`label ${onDark ? 'text-paper/75' : 'text-ink-60'}`}>{author}</span>
    </div>
  );
}
